import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import type { BoardStateVo } from 'types/insuranceBilling';
import { getStateStyle } from './statusConfig';
import s from './s.module.less';

type Props = {
    // 服务端的展示状态：文案用 label / hint，颜色按 key 对照原型
    state?: BoardStateVo | null;
    // drawer 头部等无 tooltip 场景
    showTip?: boolean;
};

const StatusBadge = ({ state, showTip = true }: Props) => {
    if (!state) return null;
    const style = getStateStyle(state.key);
    const tip = state.hint;
    const badge = (
        <span className={s.badge} style={{ background: style.bg, color: style.color }}>
            {state.label}
            {showTip && tip && <QuestionCircleOutlined className={s.badgeTipIcon} />}
        </span>
    );
    if (!showTip || !tip) return badge;
    // 表格滚动时浮层跟随锚点，隐藏后销毁：避免抽屉打开后还有残留的 tooltip 浮在上面
    return (
        <Tooltip title={tip} destroyTooltipOnHide>
            {badge}
        </Tooltip>
    );
};

export default StatusBadge;
